(function(){
    const seasonTicketsDiv = document.querySelectorAll('.spektrix-season-tickets');
    if(!seasonTicketsDiv || seasonTicketsDiv.length==0) return;
    const seasonTicketSubmit = document.querySelectorAll('.submit_season_ticket');
    const seasonTicketsLogin = document.querySelectorAll('.spektrix-season-tickets-login');
    let loggedInFlag = false;
    fetch(`${FETCH_URL}customer`,{credentials: 'include'})
    .then(response=>response.json())
    .then(data=>{
        if(data && data.id){
            loggedInFlag = true;
        } 
    });
    seasonTicketSubmit.forEach(submit=>{
        submit.addEventListener('click',(e)=>{

            e.currentTarget.parentNode.classList.add('loading');
            let activeButton = e.currentTarget.parentNode.querySelector('.btn-info');
            let membershipID = activeButton.dataset.season_ticket_id;
            data=[{membership:membershipID}];
            let fetchHeaders = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(data) 
            }
            let fetchHeadersInstances = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(INSTANCES[membershipID]) 
            }
            fetch(`${FETCH_URL}basket/membership-subscriptions`, fetchHeaders)
                .then(response=>response.json())
                .then(data=>{
                    if(data.errorCode){
                        seasonTicketsDiv.forEach(div=>{ 
                            div.classList.remove('loading');
                            div.insertAdjacentHTML('afterend',`<div class="error">${data.message}</div>`)
                        }); 
                        console.log(data.message);
                    }
                    else{
                        if(INSTANCES[membershipID].length!=0){
                            fetch(`${FETCH_URL}basket/tickets`,fetchHeadersInstances)
                            .then(response=>response.json())
                            .then(data=>{
                                if(data.errorCode){
                                    seasonTicketsDiv.forEach(div=>{
                                        div.classList.remove('loading');
                                        div.insertAdjacentHTML('afterend',`<div class="error">${data.message}</div>`)
                                    }); 
                                    console.log(data.message);
                                }
                                else{
                                    if(loggedInFlag){
                                        window.location.href ='/basket';
                                    }
                                    else{
                                        seasonTicketsDiv.forEach(div=>{
                                            div.classList.remove('loading');
                                            div.classList.add('hide');
                                        }); 
                                        seasonTicketsLogin.forEach(div=>{
                                            div.classList.remove('hide');
                                        })
                                    }
                                }
                            })
                            .catch(error=>console.log(error));
                        }
                        else{
                            window.location.href ='/basket';
                        }
                    }
                })
                .catch(error=>console.log(error));
            
        })
    })

    async function postData(url,urlInstances, data, dataInstances) {
        
        const response = await Promise.all(
            [fetch(url, fetchHeaders).then(response=>response.json()),
            fetch(urlInstances,fetchHeadersInstances).then(response=>response.json())
        ]);
        return response; 
    }
    window.addEventListener('load',()=>{
        window.scrollTo(0,0);
    })
})()
